import { localizeWithPath } from 'vscode/vscode/vs/nls';
import { OS } from 'vscode/vscode/vs/base/common/platform';
import { Extensions } from 'vscode/vscode/vs/platform/configuration/common/configurationRegistry';
import { Registry } from 'vscode/vscode/vs/platform/registry/common/platform';

const _moduleId = "vs/platform/keyboardLayout/common/keyboardConfig";
function readKeyboardConfig(configurationService) {
    const keyboard = configurationService.getValue('keyboard');
    const dispatch = ((keyboard?.dispatch === 'keyCode' ? 1  : 0) );
    const mapAltGrToCtrlAlt = Boolean(keyboard?.mapAltGrToCtrlAlt);
    return { dispatch, mapAltGrToCtrlAlt };
}
const configurationRegistry = ( (Registry.as(Extensions.Configuration)));
const keyboardConfiguration = {
    'id': 'keyboard',
    'order': 15,
    'type': 'object',
    'title': ( localizeWithPath(_moduleId, 0, "Keyboard")),
    'properties': {
        'keyboard.dispatch': {
            scope: 1 ,
            type: 'string',
            enum: ['code', 'keyCode'],
            default: 'code',
            markdownDescription: ( localizeWithPath(
                _moduleId,
                1,
                "Controls the dispatching logic for key presses to use either `code` (recommended) or `keyCode`."
            )),
            included: OS === 2  || OS === 3
        },
        'keyboard.mapAltGrToCtrlAlt': {
            scope: 1 ,
            type: 'boolean',
            default: false,
            markdownDescription: ( localizeWithPath(
                _moduleId,
                2,
                "Controls if the AltGraph+ modifier should be treated as Ctrl+Alt+."
            )),
            included: OS === 1
        }
    }
};
configurationRegistry.registerConfiguration(keyboardConfiguration);

export { readKeyboardConfig };
